const FALLBACK = "/dashboard";

/**
 * Validates and sanitizes a redirect path to prevent open redirect attacks.
 * Only allows true relative paths (starting with a single slash).
 * Rejects protocol-relative URLs (//), encoded bypasses, and backslash tricks.
 */
export function getSafeRedirectPath(
  redirectTo: string | undefined,
  fallback: string = FALLBACK,
): string {
  if (!redirectTo) return fallback;

  if (!redirectTo.startsWith("/") || redirectTo.startsWith("//")) {
    return fallback;
  }

  try {
    const decoded = decodeURIComponent(redirectTo);
    if (!decoded.startsWith("/") || decoded.startsWith("//")) {
      return fallback;
    }
    if (decoded.includes("\\")) {
      return fallback;
    }
    if (/^\/[a-zA-Z][a-zA-Z0-9+.-]*:/.test(decoded)) {
      return fallback;
    }
  } catch {
    return fallback;
  }

  return redirectTo;
}
